import React from "react";
import { Breath, Footer, NavTech, Personality } from "../components";

const Personal = () => {
  return (
    <>
      <Personality />
      <Breath />
      <Footer />
    </>
  );
};

export default Personal;
